import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Fragment, useState } from "react";
import { useMutation } from "@apollo/client";
import { Dialog, PrimaryButton } from "@crehana/ui";
import { useMainMenuContext, useMainMenuTranslation } from "../../hooks";
import PhoneInput, { usePhoneNumberState } from "../../../PhoneInput";
var MAIN_MENU_ADD_CONTACT = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "MainMenuAddContact"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "name"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "email"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "birthDate"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "phoneNumber"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "source"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ContactSourceEnum"
          }
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "categoryId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ID"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "absoluteUrl"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "addContactData"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "name"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "name"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "email"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "email"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "birthDate"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "birthDate"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "phoneNumber"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "phoneNumber"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "source"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "source"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "categoryId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "categoryId"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "absoluteUrl"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "absoluteUrl"
                }
              }
            }]
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "token"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "response"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "code"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "message"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 482,
    source: {
      body: "mutation MainMenuAddContact(\n  $name: String!\n  $email: String\n  $birthDate: String\n  $phoneNumber: String\n  $source: ContactSourceEnum!\n  $categoryId: ID\n  $absoluteUrl: String\n) {\n  addContactData(\n    input: {\n      name: $name\n      email: $email\n      birthDate: $birthDate\n      phoneNumber: $phoneNumber\n      source: $source\n      categoryId: $categoryId\n      absoluteUrl: $absoluteUrl\n    }\n  ) {\n    success\n    token\n\n    response {\n      code\n      message\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
import locales from "./i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CallCenter = function CallCenter() {
  var _layoutConfig$phoneIn;
  var _useMainMenuContext = useMainMenuContext(),
    themeName = _useMainMenuContext.themeName,
    layoutConfig = _useMainMenuContext.layoutConfig,
    me = _useMainMenuContext.me;
  var shouldRenderPhoneInput = !(layoutConfig !== null && layoutConfig !== void 0 && (_layoutConfig$phoneIn = layoutConfig.phoneInputProps) !== null && _layoutConfig$phoneIn !== void 0 && _layoutConfig$phoneIn.hide);
  var _useMainMenuTranslati = useMainMenuTranslation(),
    t = _useMainMenuTranslati.t,
    _useMainMenuTranslati2 = _useMainMenuTranslati.countryCode,
    countryCode = _useMainMenuTranslati2 === void 0 ? 'pe' : _useMainMenuTranslati2,
    addResourceBundle = _useMainMenuTranslati.addResourceBundle;
  var _useMutation = useMutation(MAIN_MENU_ADD_CONTACT),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    saveContactMutation = _useMutation2[0];
  var _usePhoneNumberState = usePhoneNumberState(),
    phoneState = _usePhoneNumberState.phoneState,
    setPhoneState = _usePhoneNumberState.setPhoneState;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSavedContact = _useState6[0],
    setIsSavedContact = _useState6[1];
  addResourceBundle(locales);
  var onSaveContact = function onSaveContact() {
    var phoneNumber = phoneState.phoneNumber;
    if (phoneNumber) {
      var _me$firstName, _layoutConfig$phoneIn2;
      saveContactMutation({
        variables: {
          name: (me === null || me === void 0 ? void 0 : (_me$firstName = me.firstName) === null || _me$firstName === void 0 ? void 0 : _me$firstName.substring(0, 50)) || '',
          email: (me === null || me === void 0 ? void 0 : me.email) || '',
          phoneNumber: phoneState.fullNumber,
          source: layoutConfig === null || layoutConfig === void 0 ? void 0 : (_layoutConfig$phoneIn2 = layoutConfig.phoneInputProps) === null || _layoutConfig$phoneIn2 === void 0 ? void 0 : _layoutConfig$phoneIn2.source
        }
      }).then(function (success) {
        if (success) {
          setIsOpen(true);
        }
      })["catch"](function () {
        return setErrorMessage('');
      });
    } else {
      setErrorMessage(t('PHONE_REQUIRED'));
    }
  };
  var onInputChange = function onInputChange(phone) {
    setErrorMessage(phone.phoneNumber.length > 1 ? phone.error : '');
    setPhoneState(phone);
  };
  var closeDialog = function closeDialog() {
    setIsSavedContact(true);
    setIsOpen(false);
  };
  if (isSavedContact || !shouldRenderPhoneInput) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center",
        children: [errorMessage && /*#__PURE__*/_jsx("p", {
          className: "mr-8 font-caption text-red-main",
          role: "alert",
          children: errorMessage
        }), /*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: 203
          },
          className: "mr-8",
          children: /*#__PURE__*/_jsx(PhoneInput, {
            isDark: themeName.nav === 'dark',
            defaultCountry: countryCode,
            size: "s",
            hideErrorMessage: true,
            onChange: onInputChange
          })
        })]
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        isDark: themeName.nav === 'dark',
        size: "s",
        label: t('CTA_INPUT_PHONE'),
        onClick: onSaveContact
      })]
    }), /*#__PURE__*/_jsx(Dialog, {
      open: isOpen,
      onDismiss: closeDialog,
      size: "l",
      hideCloseBtn: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col items-center justify-center h-screen px-24 py-48 bg-base-dark sm:justify-start sm:h-auto",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "mb-24 sm:mb-32",
          children: [/*#__PURE__*/_jsx("p", {
            className: "mb-16 text-center text-white font-h2",
            children: t('MAIN_MENU_PHONE_INPUT_THANKS_TITLE')
          }), /*#__PURE__*/_jsx("p", {
            className: "text-center text-white font-body3",
            children: t('MAIN_MENU_PHONE_INPUT_THANKS')
          })]
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          isDark: true,
          size: "l",
          label: t('MAIN_MENU_PHONE_INPUT_END'),
          onClick: closeDialog
        })]
      })
    })]
  });
};
export default CallCenter;